export const TYPES = {
    IEnvironmentService: Symbol('IEnvironmentService'),
};
